<div class="modal-content">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="modal.hide()"><span aria-hidden="true">&times;</span></button>
        <h3 class="modal-title">Visualizar imagem</h3>
    </div>
    <div class="modal-body centered">
        <img *ngIf="!isPdf" [src]="getSafeURL(imagem.url)" [alt]="imagem.name" style="max-width: 100%;max-height: 80vh;">
        <iframe *ngIf="isPdf" [src]="imagem.url" style="width: 100%; height: 80vh" title="imagem"></iframe>
    </div>
</div>
